import React, { useState } from 'react';
import ArrowIcon from "../svg-components/ArrowIcon";

const MailchimpSignUp = () => {

    const [email,setEmail] = useState("");
    const [verification,setVerification] = useState("");

    return (
        <form
            action="https://flauntdigital.us5.list-manage.com/subscribe/post?u=05a5e37433b48049dd6a052d5&amp;id=3aba5d947e&amp;f_id=000e83e9f0"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            className="sign-up-form"
            target="_blank"
            rel="noreferrer"
        >
            <h3>a flaunt newsletter. industry news, flaunt insight, memes.</h3>
            <input
                type="email"
                value={email}
                onChange={e => setEmail(e.currentTarget.value)}
                name="EMAIL"
                autoComplete="email"
                placeholder='Enter your email address'
                className="sign-up-email"
                id="mce-EMAIL"
                required 
            />
            <input
                type="hidden"
                name="tags"
                value="4045073" 
            />
            <div
                style={{position: 'absolute', left: '-5000px'}}
                aria-hidden="true"
            >
                <input
                    type="text"
                    name="b_05a5e37433b48049dd6a052d5_3aba5d947e"
                    value={verification}
                    onChange={e => setVerification(e.currentTarget.value)}
                    tabIndex="-1" 
                />
            </div>
            <button
                className='btn btn-newsletter text-capitalize'
                type="submit"
                name="subscribe"
                id="mc-embedded-subscribe"
            >
                Subscribe
                <div className="btn-arrow-container">
                    <ArrowIcon className="btn-arrow"/>
                </div>
            </button>
        </form>
    );
};

export default MailchimpSignUp;